const BaseService = require('@/services/BaseService')

const namespace = 'cleanings'

const find = (id, options, cb) => {
  BaseService.get(namespace + '/' + id, options, cb);
}

const findAll = (options, cb) => {
  BaseService.get(namespace, options, cb);
}

const create = (options, cb, errorCb) => {
    BaseService.post(namespace, options, cb, errorCb);
}

export {
  find,
  findAll,
  create
}


// WEBPACK FOOTER //
// ./src/services/cleaning/CleaningService.js